const PRODUCT_TYPES = Object.freeze({
  SAVINGS: "SAVINGS",
  CHECKING: "CHECKING",
  CD: "CD"
});

export default PRODUCT_TYPES;
